import React from 'react';
import type { useForm } from 'react-hook-form';
import { Controller } from 'react-hook-form';
import styled from 'styled-components';

import { Flexbox, Label } from '@seuk/design-system/atoms';
import { PhoneNumberField, Radio, TextField, ControlledSelect } from '@seuk/design-system/molecules';
import { EMAIL_REGEX } from '@seuk/shared-data';

import errorMessages from '../../data/error-messages';
import { phoneNumberValidator } from '../../util/phone-number-validator';
import type { ContactMethodFormValues } from '../forms/types';

export interface ContactMethodProps {
  methods: unknown;
  //methods: ReturnType<typeof useForm>;
}

const RadioGroup = styled(Flexbox)`
  gap: ${({ theme }) => theme.spacing(2)};
  flex-direction: column;
`;

const CONTACT_TIME_OPTIONS = [
  'Anytime (8am - 6pm)',
  'Morning (8am - 12pm)',
  'Afternoon (12pm - 3pm)',
  'Late afternoon (3pm - 6pm)',
].map((item) => {
  return {
    label: item,
    value: item,
  };
});

const CONTACT_OPTIONS = ['Email', 'Phone', 'Either'] as const;
const PHONE_CONTACT_OPTIONS = ['Phone', 'Either'];
const EMAIL_CONTACT_OPTIONS = ['Email', 'Either'];

export const ContactMethod = ({ methods: formMethods }: ContactMethodProps) => {
  // todo fix methods types
  const methods = formMethods as ReturnType<typeof useForm<ContactMethodFormValues>>;
  const contactMethod = methods.watch('contactMethod');
  const errors = methods.formState.errors;

  return (
    <>
      <RadioGroup>
        <Label>Preferred contact method*</Label>
        {CONTACT_OPTIONS.map((option) => {
          return (
            <Radio
              name="contactMethod"
              key={option}
              label={option}
              value={option}
              {...methods.register('contactMethod', { required: true })}
            />
          );
        })}
      </RadioGroup>
      {PHONE_CONTACT_OPTIONS.includes(contactMethod) && (
        <>
          <Controller
            name="contactNumber"
            rules={{ validate: phoneNumberValidator }}
            render={({ field: { onChange, value } }) => (
              <PhoneNumberField
                label="Telephone number"
                id="phone"
                value={value}
                onChange={onChange}
                error={errors['contactNumber']}
              />
            )}
          />
          <ControlledSelect label="Best time to call" name="timeToCall" id="timeToCall" items={CONTACT_TIME_OPTIONS} />
        </>
      )}
      {EMAIL_CONTACT_OPTIONS.includes(contactMethod) && (
        <>
          <TextField
            id="email"
            label="Email*"
            error={methods.formState.touchedFields.email && errors.email && { message: errorMessages.email }}
            {...methods.register('email', {
              required: true,
              pattern: EMAIL_REGEX,
            })}
          />
        </>
      )}
    </>
  );
};
